"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icons = _interopRequireDefault(require("../icons"));

var _Card = _interopRequireDefault(require("../Card"));

var _proptypes = require("../utils/proptypes");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Panel =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Panel, _PureComponent);

  function Panel() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Panel.prototype;

  _proto.getStyle = function getStyle() {
    var _this$props = this.props,
        width = _this$props.width,
        height = _this$props.height,
        top = _this$props.top,
        position = _this$props.position,
        style = _this$props.style;
    return Object.assign({
      position: 'absolute'
    }, position ? {} : {
      display: 'inline-flex',
      width: width,
      height: height,
      top: top,
      position: 'relative'
    }, style || {});
  } // eslint-disable-next-line
  ;

  _proto.lockWheel = function lockWheel(event) {
    event.preventDefault();
  };

  _proto.renderContent = function renderContent() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        noPadding = _this$props2.noPadding,
        title = _this$props2.title,
        type = _this$props2.type,
        padding = _this$props2.padding,
        position = _this$props2.position,
        bodyStyle = _this$props2.bodyStyle;
    var style = {
      padding: noPadding === true ? 0 : padding
    };
    if (position) style.overflow = 'auto';
    if (bodyStyle) style = Object.assign(style, bodyStyle);
    if (type === 'default') return _react.default.createElement(_Card.default.Body, {
      style: style
    }, children);
    var iconType = type.charAt(0).toUpperCase() + type.slice(1);
    var icon = _icons.default[iconType];
    return _react.default.createElement(_Card.default.Body, {
      className: (0, _styles.modalClass)('body'),
      style: style
    }, icon && _react.default.createElement("div", {
      className: (0, _styles.modalClass)('icon')
    }, icon), title && _react.default.createElement("div", {
      className: (0, _styles.modalClass)('title')
    }, title), _react.default.createElement("div", null, children));
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        footer = _this$props3.footer,
        title = _this$props3.title,
        type = _this$props3.type,
        onClose = _this$props3.onClose,
        maskCloseAble = _this$props3.maskCloseAble,
        position = _this$props3.position;
    var className = (0, _classnames.default)((0, _styles.modalClass)('panel', type, position), this.props.className);
    return [_react.default.createElement("div", {
      key: "mask",
      className: (0, _styles.modalClass)('mask'),
      onClick: maskCloseAble ? onClose : undefined
    }), _react.default.createElement(_Card.default, {
      key: "card",
      shadow: true,
      className: className,
      style: this.getStyle()
    }, (maskCloseAble || maskCloseAble === null) && _react.default.createElement("a", {
      className: (0, _styles.modalClass)('close'),
      onClick: onClose,
      href: "javascript:;"
    }, _icons.default.Close), title && type === 'default' && _react.default.createElement(_Card.default.Header, {
      className: (0, _styles.modalClass)('title')
    }, title), this.renderContent(), footer && _react.default.createElement(_Card.default.Footer, {
      className: (0, _styles.modalClass)('footer'),
      align: "right"
    }, footer))];
  };

  return Panel;
}(_react.PureComponent);

exports.default = Panel;
Panel.displayName = 'ShineoutModalPanel';
Panel.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default), {
  footer: _propTypes.default.any,
  maskCloseAble: _propTypes.default.bool,
  noPadding: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  position: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  type: _propTypes.default.string,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
});
Panel.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  top: '10vh',
  maskCloseAble: true,
  width: 500
});